import React, { useState } from 'react';
import { Col, Row } from 'antd';
import { useHistory } from 'react-router-dom';
import { TriptychLayout } from '../../components/layout/TriptychLayout';
import formCol from '../../utils/formCol';
import TrackingForm from './components/TrackingForm';
import EnrollmentHistory from './components/EnrollmentHistory';
import './styles.less';

const TrackingPage = () => {
  const [enrollmentHistory, setEnrollmentHistory] = useState();
  const history = useHistory();

  const cleanEnrollmentHistory = () => {
    setEnrollmentHistory(undefined);
    history.push('/enrolamiento/seguimiento');
  };

  const renderContent = () => {
    if (enrollmentHistory) {
      return (
        <EnrollmentHistory
          enrollmentHistory={enrollmentHistory}
          onFinish={cleanEnrollmentHistory}
        />
      );
    }

    return <TrackingForm onEnrollmentHistoryObtain={setEnrollmentHistory} />;
  };

  return (
    <TriptychLayout noAppendPadding>
      <h1 className="tracking-title">Seguimiento de solicitud</h1>
      <Row justify="center">
        <Col span={formCol.responsive}>{renderContent()}</Col>
      </Row>
      <div className="tracking__background" />
      <></>
    </TriptychLayout>
  );
};

export default TrackingPage;
